import { Card, Grid } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import FichaRepresentante from "../gestRepresentantes/fichaRepresentante";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import { useEffect, useState } from "react";
import ImagemEdit from "../../utils/imagemEdit";
import Delete from "../../utils/delete";
import ChangeRepresentante from "./changeRepresentante";
import InfoFieldGroup from "../../utils/InfoField/InfoFieldGroup";
import { useSelector } from "react-redux";
import api from "../../services/api";

export default function FichaEmpresa({ empresa, header, setRefresh, local }) {
    const user = useSelector(state => state.account.user);
    const [editDados, setEditDados] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('');
    const [messageError, setMessageError] = useState('');
    const [openEditLogo, setEditLogo] = useState(false);
    const [load, setLoad] = useState(false);
    const [changeRepresentante, setChangeRepresentante] = useState(false);
    const [municipios, setMunicipios] = useState([]);
    const [provincias, setProvincias] = useState([]);

    useEffect(() => {
        if (isEdit) {
            api.get('/provincias')
                .then(res => {
                    setProvincias(res.data.provincias);

                }).catch(err => '')
        }
    }, [isEdit])

    useEffect(() => {
        if (editDados?.provinciaId) {
            api.get(`/municipios-by-provincia/${editDados?.provinciaId}`)
                .then(res => {
                    setMunicipios(res.data.municipios);
                    setEditDados((prev) => ({ ...prev, provincia: res.data.provincia.designacao }));
                }).catch(err => 'console.log(err)')
        }
    }, [editDados?.provinciaId])

    const submitEdit = async () => {

        setLoad(true)
        setMessageSuccess('')
        setMessageError('')

        await api.put('/empresa/edit', { ...editDados, 'empresaId': empresa._id, 'userId': user?._id ?? '' })
            .then(res => {
                // console.log(editDados)
                // setDadosEmpresa(res.data.empresa)
                setRefresh(res.data.empresa)
                setLoad(false)
                setMessageSuccess(res.data.msg)
                setIsEdit(false)

            }).catch(err => {
                // console.log(err)
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }

    return (empresa ?
        <>
            <Card style={{ padding: 20, minHeight: '20vh', marginBottom: 20, marginTop: 20 }}>
                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && <MessageError message={messageError} />}

                <Delete
                    // open={load}
                    // setLoad={setLoad}
                    id={empresa?._id}
                    tipo={'Empresa'}
                    url={'/empresa/delete'}
                    msg={`Tem certeza que deseja eliminar a Empresa ${empresa?.nome}`}
                />

                <ChangeRepresentante
                    empresa={empresa}
                    open={changeRepresentante}
                    setOpen={setChangeRepresentante}
                    setLoad={setChangeRepresentante}
                />

                {header &&
                    <HeaderGestorConfigs
                        menu={true}
                        title={isEdit ? 'EDITAR DADOS' : 'FICHA DA EMPRESA'}
                        configArea={'dadosempresa'}
                        empresa={empresa}
                        editDados={isEdit}
                        setEditDados={setIsEdit}
                        setChangeRepresentante={setChangeRepresentante}
                        delete={setLoad}
                    />
                }

                <Grid container>
                    {!isEdit &&
                        <Grid item marginRight={2}>
                            <ImagemEdit
                                data={empresa}
                                url={'/empresa/change-logo'}
                                local={'empresaId'}
                                openEditLogo={openEditLogo}
                                setOpenEditLogo={setEditLogo}
                            />
                        </Grid>
                    }

                    <Grid xs item>
                        <InfoFieldGroup
                            submit={submitEdit}
                            data={editDados}
                            // handleChange={handleChange}
                            setIsEdit={setIsEdit}
                            isEdit={isEdit}
                            load={load}
                            fields={
                                [
                                    { label: 'Estado', value: empresa?.status, editable: false, },
                                    { label: 'Nome', value: empresa?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                    { label: 'NIF', value: empresa?.nif, key: 'nif', onChange: (v) => setEditDados({ ...editDados, nif: v.target.value }) },
                                    { label: 'Representante', value: empresa?.representante?.dadosPessoais?.nome, editable: false },
                                    // { label: 'E-mail', value: empresa?.email, editable: true, onChange: (v) => setEmpresa({ ...empresa, email: v.target.value }) },
                                    { label: 'E-mail', value: empresa?.email, key: 'email', onChange: (v) => setEditDados({ ...editDados, email: v.target.value }) },
                                    { label: 'Telefone 1', value: empresa?.tel1, key: 'tel1', onChange: (v) => setEditDados({ ...editDados, tel1: v.target.value }) },
                                    { label: 'Telefone 2', value: empresa?.tel2, key: 'tel2', onChange: (v) => setEditDados({ ...editDados, tel2: v.target.value }) },
                                    { label: 'Província', value: empresa?.provincia, key: 'provinciaId', type: 'select', options: provincias, onChange: (v) => setEditDados({ ...editDados, provinciaId: v.target.value }) },
                                    { label: 'Município', value: empresa?.municipio, key: 'municipio', type: 'select', options: municipios, onChange: (v) => setEditDados({ ...editDados, municipio: v.target.value }) },
                                    { label: 'Bairro', value: empresa?.bairro, key: 'bairro', onChange: (v) => setEditDados({ ...editDados, bairro: v.target.value }) },
                                    { label: 'Rua / Avenida', value: empresa?.rua, key: 'rua', onChange: (v) => setEditDados({ ...editDados, rua: v.target.value }) },
                                ]
                            } />
                    </Grid>
                </Grid>
            </Card>

            {/* EXIBIR FICHA DO REPRESENTANTE JUNTAMENTE COM A FICHA DA EMPRESA */}
            {(local === 'gestEmpresa' || local === 'analiseSolicitacao') &&
                <FichaRepresentante header={header} representante={empresa?.representante} setRefresh={setRefresh} />
            }
        </>
        :
        <Loading />
    )
}